import { gql } from "@apollo/client";

const CLEAR_INTELLI_UPLOAD_DOCUMENTS = gql`
  mutation ClearQueue($params: IntelliUploadClearInput!) {
    clearQueue(params: $params) {
      success
      message
    }
  }
`;

export default CLEAR_INTELLI_UPLOAD_DOCUMENTS;